export default __webpack_public_path__ + "static/redislide3-c2aae226a4eec5138caf4f3302b81e1d.jpg";